import styled from '@emotion/styled';
import Container from '../../../components/blocks/Container';
import { getBackgroundTheme, getBorders, getTextType, getTextColor, getInputTheme } from '../../../style';
import breakpoints from '../../../theme/material/breakpoints';
import { FONT_FAMILIES } from '../../../theme/material/constants';
import { Typography } from '@material-ui/core';
import colors, { primaryBG } from '../../../theme/colors';
import { isDarkMode } from '../../../utils/helpers';

export const MainContainer = styled(Container)(() => ({
  fontFamily: FONT_FAMILIES.primary,
  display: 'flex',
  marginTop: '40px',
  alignItems: 'self-start',
  justifyContent: 'center',
  maxWidth: 600,
  minHeight: '728px',
  backgroundColor: `${getBackgroundTheme().personalInfo}`,
  borderRadius: '10px',
  padding: '26px 30px',
  border: getBorders().DEFAULT,
  [breakpoints.down('md')]: {
    margin: '22px auto',
  },
  [breakpoints.between(600, 690)]: {
    margin: '22px 15px',
    alignContent: 'center',
  },
  [breakpoints.down('xs')]: {
    minHeight: '435px',
    borderRadius: '5px',
    margin: '0px 15px',
    alignItems: 'self-start',
    padding: '30px 15px',
  },
}));

export const Content = styled.div({
  width: '100%',
});

export const Title = styled('h1')(() => ({
  ...getTextType().header,
  lineHeight: 'normal',
  letterSpacing: '-0.4px',
  margin: 0,
  textTransform: 'none',
  [breakpoints.down(768.05)]: {
    textAlign: 'center',
  },
}));

export const BottomContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
});

export const Description = styled('p')(() => ({
  margin: 0,
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '20px',
  ...getTextColor().LIGHT_GRAY,
}));

export const HeadlineStyle = styled('h1')(() => ({
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '19px',
  letterSpacing: '-0.36px',
  color: `${getBackgroundTheme().changeEmailBottomHeadline}`,
  margin: 0,
}));

export const LabelStyle = styled(Typography)(() => ({
  ...getTextColor().LIGHT_GRAY,
  fontSize: 15,
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: '-0.3px',
  textAlign: 'center',
}));

export const EmailStyle = styled(Typography)(() => ({
  ...getTextColor().LIGHT_GRAY,
  fontSize: 15,
  marginTop: 15,
  fontWeight: 700,
  textAlign: 'center',
  letterSpacing: ' -0.3px',
}));

export const ButtonWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  alignSelf: 'center',
  maxWidth: 315,
  textAlign: 'center',
});

export const LinkedSocialAccounts = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  textAlign: 'center',
});

export const LinkedSocialAccountItem = styled('div')({
  display: 'flex',
  gap: 5,
  alignSelf: 'center',
  textAlign: 'center',
  marginTop: 15,
});

export const successTextStyle = {
  fontSize: 22,
  fontWeight: 600,
  letterSpacing: '-0.44px',
  lineHeight: '20px',
  color: colors.light.green.primary,
  marginBottom: 20,
};

export const OtpNextButtonWrapper = styled('div')({
  margin: '20px 0px',
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  flexDirection: 'column',
});

export const usePassOtpLink = {
  padding: '4px 0',
  textAlign: 'center',
  marginBottom: 20,
};

export const customLabelStyle = {
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '-0.3px',
};

export const emailInputStyle = {
  fontSize: '15px !important',
  fontWeight: 400,
  lineHeight: '20px !important',
  letterSpacing: '-0.3px',
  height: '50px !important',
  color: `${getInputTheme().textInput} !important`,
  background: `${isDarkMode() ? colors.blue['800'] : primaryBG} !important`,
};
